export default "__VITE_ASSET__CU_D1O9I__"